import path from 'node:path'
import { listSchemaNames } from '@core-engine/schema/schema-reader/list-schema-names.js'
import { resolveProjectPaths } from '@next-adapter/config/paths/resolve-project-paths.js'
import { resolveConfigOrExit } from '@next-adapter/config/resolve-config-or-exit.js'

export async function listSchemaChoices(cwd: string): Promise<string[]> {
  const config = await resolveConfigOrExit(cwd)
  const paths = resolveProjectPaths(config)
  return listSchemaNames(path.join(cwd, ...paths.schemasDir.split('/')))
}
